module.exports = __webpack_public_path__ + "assets/img/2.5c14f040.png";